import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
export default class checkInResultModal extends Modal {
  className() {
    return 'checkInResultModal Modal--small';
  }
  title() {
    return m("div", {
      className: "checkInResultModal successTitleText"
    }, app.translator.trans('ziven-checkin.forum.check-in-success'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "checkInResultModal successText"
    }, this.attrs.text));
  }
}
flarum.reg.add('ziiven-daily-check-in', 'forum/components/checkInSuccessModal', checkInResultModal);